import React from "react";
import { LuQuote } from "react-icons/lu";
import { FaStar } from "react-icons/fa";

type ICarouselAutoPlay = {
  items: any[];
};

const CarouselAutoPlay: React.FC<ICarouselAutoPlay> = ({ items }) => {
  return (
    <div className="pb-8">
      <div className="flex flex-col items-center">
        <div className="inline-flex items-center gap-2 bg-primary-900 px-4 py-2 rounded-full shadow-md mb-8">
          <span className="flex h-2 w-2 relative">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-customyellow opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-customyellow"></span>
          </span>
          <h4 className="text-sm font-medium text-customyellow">
            Testimonials
          </h4>
        </div>
        <h2 className="text-3xl text-center font-bold mb-14 md:font-[600] md:text-4xl text-primary-900 capitalize">
          Don't just take our words
        </h2>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {items.map((item, index) => (
          <div
            key={index + 1}
            className="flex flex-col justify-between align-center bg-white rounded-xl p-8 shadow-lg relative transition-all duration-300 hover:shadow-xl"
          >
            <div className="flex mb-4">
              {[...Array(5)].map((_, i) => (
                <FaStar
                  key={i}
                  className="w-5 h-5 text-[#facc15] fill-current"
                />
              ))}
            </div>
            <div className="absolute -top-4 left-8">
              <div className="bg-primary-600 p-2 rounded-full">
                <LuQuote className="w-6 h-6 text-white" />
              </div>
            </div>

            <p className="text-gray-700 mb-6 italic">"{item.description}"</p>
            <div>
              <div className="font-semibold text-gray-800">{item.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarouselAutoPlay;
